import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

export const StepShell = ({ children, stepKey, onBack, progress, testId }) => (
  <motion.section
    key={stepKey}
    initial={{ opacity: 0, y: 14 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -8 }}
    transition={{ duration: 0.32, ease: "easeOut" }}
    className="mx-auto flex min-h-[calc(100dvh-60px)] w-full max-w-xl flex-col px-5 pb-6 pt-5"
    data-testid={testId}
  >
    {(onBack || progress) && (
      <div className="mb-6 flex items-center gap-4">
        {onBack && (
          <button
            onClick={onBack}
            className="-ml-2 flex h-11 w-11 items-center justify-center rounded-full text-neutral-600 transition-colors hover:bg-neutral-100"
            aria-label="Back"
            data-testid="step-back-button"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
        )}
        {progress && (
          <div className="flex flex-1 items-center gap-3" data-testid="question-progress">
            <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-neutral-100">
              <motion.div
                className="h-full rounded-full bg-[#138808]"
                initial={false}
                animate={{ width: `${(progress.index / progress.total) * 100}%` }}
                transition={{ duration: 0.4 }}
              />
            </div>
            <span className="text-xs tabular-nums text-neutral-500">{progress.index}/{progress.total}</span>
          </div>
        )}
      </div>
    )}
    {children}
  </motion.section>
);

export const Eyebrow = ({ children }) => (
  <p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-[var(--saffron-deep)]">{children}</p>
);

export const Title = ({ children, className = "" }) => (
  <h1 className={`font-display text-[2rem] font-medium leading-[1.12] text-[#1f2328] sm:text-5xl ${className}`}>{children}</h1>
);

export const BottomBar = ({ children }) => (
  <div className="sticky bottom-0 mt-auto -mx-5 bg-gradient-to-t from-white via-white to-white/0 px-5 pb-2 pt-6">{children}</div>
);

export const PrimaryButton = ({ children, className = "", ...props }) => (
  <button className={`btn-saffron flex h-14 w-full items-center justify-center gap-2 rounded-full text-base font-semibold ${className}`} {...props}>
    {children}
  </button>
);

export const GhostButton = ({ children, className = "", ...props }) => (
  <button
    className={`flex h-14 w-full items-center justify-center gap-2 rounded-full border border-neutral-300 text-base font-medium text-[#1f2328] transition-colors hover:border-neutral-500 ${className}`}
    {...props}
  >
    {children}
  </button>
);

export const Choice = ({ selected, children, sub, ...props }) => (
  <button
    data-selected={selected ? "true" : "false"}
    className="choice flex min-h-[56px] w-full items-center justify-between gap-3 rounded-2xl border border-neutral-200 bg-white px-5 py-3 text-left text-[15px] font-medium text-[#1f2328]"
    {...props}
  >
    <span>
      {children}
      {sub && <span className="block text-xs font-normal text-neutral-500">{sub}</span>}
    </span>
    <span className={`h-5 w-5 shrink-0 rounded-full border-2 ${selected ? "border-[#138808] bg-[#138808] shadow-[inset_0_0_0_3px_white]" : "border-neutral-300"}`} />
  </button>
);
